module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[92]213.d192ddd.woff2";